import { render, staticRenderFns } from "./taps.vue?vue&type=template&id=033b580c&"
import script from "./taps.vue?vue&type=script&lang=js&"
export * from "./taps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports